import { MouseEvent, ReactNode } from 'react';
import styles from './Card.module.css';

export type CardProps = {
  children: ReactNode;
  className?: string;
  interativo?: boolean;
  onClick?: (evento: MouseEvent<HTMLDivElement>) => void;
};

export default function Card({ children, className, interativo, onClick }: CardProps) {
  return (
    <div
      className={`${styles.card} ${interativo ? styles.interativo : ''} ${className ?? ''}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
